import React from "react";
import { RouteObject } from "react-router-dom";

import { ADMIN_ROUTES } from "../../routes";

export const AdminRoutes: RouteObject[] = [
  {
    path: ADMIN_ROUTES.AdminOverview,
    lazy: async () => {
      const { AdminOverviewRoute } = await import(
        "@src/features/admin/pages/overview/AdminOverview.route"
      );
      const { ScopedRoute } = await import(
        "@src/components/LimitAccess/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.AdminOverview}
            adminOnly={true}
            isEnabled={() => true}
            children={AdminOverviewRoute}
          />
        ),
      };
    },
  },
  {
    path: ADMIN_ROUTES.Agencies,
    lazy: async () => {
      const { AgenciesRoute } = await import(
        "@src/features/admin/pages/agencies/Agencies.route"
      );
      const { ScopedRoute } = await import(
        "@src/components/LimitAccess/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            debugId={ADMIN_ROUTES.Agencies}
            adminOnly={true}
            isEnabled={() => true}
            children={AgenciesRoute}
          />
        ),
      };
    },
  },
];
